import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export const usecandidateTestStore = create()(
  devtools(
    persist(
      (set) => ({
        currentsectionIndex: 0,
        currentquestionindex: 0,
        testquestions: [],
        startTime: null,
        updatetestquestions: (data) => set({ testquestions: data }),
        updatecurrentsectionIndex: (index) =>
          set({ currentsectionIndex: index }),
        updateStartTime: (time) => set({ startTime: time }),
        updatecurrentquestionindex: (index) =>
          set({ currentquestionindex: index }),
      }),
      { name: 'candidatetestStore' }
    )
  )
);
